import React from 'react';
import { Tabs, Tab, Box, styled, useMediaQuery } from '@mui/material';

const StyledTabs = styled(Tabs)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
  minHeight: '48px',
  '& .MuiTabs-indicator': {
    backgroundColor: theme.palette.primary.main,
    height: '3px',
    borderRadius: '3px 3px 0 0',
  },
  '& .MuiTabs-scrollButtons.Mui-disabled': {
    opacity: 0.3,
  },
}));

const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '14px',
  minHeight: '48px',
  minWidth: 'auto',
  padding: '6px 16px',
  color: theme.palette.text.secondary,
  '&.Mui-selected': {
    color: theme.palette.primary.main,
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '12px',
    padding: '6px 10px',
  },
  [theme.breakpoints.between('sm', 'md')]: {
    fontSize: '13px',
    padding: '6px 12px',
  },
}));

const MarketTabsNav = ({ activeTab, onChange }) => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));

  const tabs = [
    { id: 'international', label: 'International Market' },
    { id: 'commodities', label: 'Commodity F&O' },
    { id: 'index-fno', label: 'Index F&O' },
    { id: 'stocks-fno', label: 'Stocks F&O' },
    { id: 'stock-discovery', label: 'Stocks' },
    // { id: 'all-indices', label: 'All Indices' },
  ];

  const handleChange = (event, newValue) => {
    onChange(newValue);
  };

  return (
    <Box sx={{ width: '100%', mb: 2 }}>
      <StyledTabs
        value={activeTab}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons={isMobile ? true : false}
        allowScrollButtonsMobile
      >
        {tabs.map((tab) => (
          <StyledTab key={tab.id} label={tab.label} value={tab.id} />
        ))}
      </StyledTabs>
    </Box>
  );
};

export default MarketTabsNav;
